/* Terroir Tastings produktside (mobile-first)
   Alle tekster hentes fra theme editoren via #tt-i18n */
(function () {
  var root = document.querySelector('[data-tt-pdp]');
  if (!root) return;
  var form = document.getElementById('tt-form');
  if (!form) return;

  var T = { add: 'Læg i kurv', soldout: 'Udsolgt', more: 'Læs mere', less: 'Vis mindre', added: 'Lagt i kurven', error: 'Kunne ikke lægge i kurv', missing: 'Du mangler [beløb] for fri fragt', free: 'Du har fri fragt', stock_in: 'På lager', stock_low: 'Få tilbage', stock_out: 'Udsolgt' };
  try {
    var i18n = JSON.parse(document.getElementById('tt-i18n').textContent);
    Object.keys(i18n).forEach(function (k) { if (i18n[k]) T[k] = i18n[k]; });
  } catch (e) {}

  var idInput = form.querySelector('input[name="id"]');
  var qty = document.getElementById('tt-qty');
  var atc = document.getElementById('tt-atc');
  var priceEl = document.getElementById('tt-price');
  var unitEl = document.getElementById('tt-unit');
  var stock = document.getElementById('tt-stock');
  var etaRow = document.getElementById('tt-eta-row');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.tt-bundle'));
  var threshold = parseInt(root.dataset.threshold, 10) || 0;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var state = {
    price: parseInt(root.dataset.price, 10) || 0,
    bottles: parseInt(root.dataset.bottles, 10) || 1,
    inv: parseInt(root.dataset.inv, 10),
    available: root.dataset.available === 'true'
  };

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
  function fmt(cents) {
    var v = cents / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  }
  function getQty() {
    var n = parseInt(qty.value, 10);
    return n > 0 ? n : 1;
  }

  function render() {
    qty.value = getQty();
    var label = state.available ? esc(T.add) + ' · <span data-tt-total></span>' : esc(T.soldout);
    [atc, document.querySelector('[data-tt-sticky-add]')].forEach(function (b) {
      if (!b) return;
      b.innerHTML = label;
      b.disabled = !state.available;
    });
    document.querySelectorAll('[data-tt-total]').forEach(function (el) {
      el.textContent = fmt(state.price * getQty());
    });
    if (priceEl) priceEl.textContent = fmt(Math.round(state.price / state.bottles));

    /* lagerstatus: in, low eller out */
    if (stock) {
      var low = parseInt(stock.dataset.low, 10) || 0;
      var st = !state.available ? 'out' : (state.inv > 0 && state.inv <= low ? 'low' : 'in');
      stock.dataset.state = st;
      var txt = stock.querySelector('[data-tt-stock-text]');
      if (txt) txt.textContent = T['stock_' + st];
    }
    if (etaRow) etaRow.hidden = !state.available;
  }

  function selectCard(card) {
    if (!card || card.dataset.available !== 'true') return;
    cards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-sel', on);
      var inp = c.querySelector('input');
      if (inp) inp.checked = on;
    });
    if (idInput.value !== card.dataset.variant) {
      idInput.value = card.dataset.variant;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    state.price = parseInt(card.dataset.price, 10);
    state.bottles = parseInt(card.dataset.bottles, 10) || 1;
    state.inv = parseInt(card.dataset.inv, 10);
    state.available = true;
    if (unitEl && card.dataset.unit) unitEl.textContent = card.dataset.unit;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', card.dataset.variant);
      window.history.replaceState(null, '', url.toString());
    } catch (e) {}
    render();
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () { selectCard(card); });
    var inp = card.querySelector('input');
    if (inp) inp.addEventListener('change', function () { if (inp.checked) selectCard(card); });
  });

  root.querySelectorAll('[data-tt-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qty.value = Math.max(1, getQty() + parseInt(btn.dataset.ttQ, 10));
      render();
    });
  });
  qty.addEventListener('change', render);

  /* galleri: swipe på mobil, thumbs på desktop */
  var track = document.getElementById('tt-slides');
  var dots = Array.prototype.slice.call(root.querySelectorAll('.tt-dots span'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.tt-thumb'));
  function setActive(i) {
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
  }
  if (track && (dots.length || thumbs.length)) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.index, 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    });
  }

  /* Læs mere på beskrivelsen (kun når teksten faktisk er klippet) */
  var hookWrap = root.querySelector('[data-tt-hook]');
  if (hookWrap) {
    var hookText = hookWrap.querySelector('.tt-hook');
    var more = hookWrap.querySelector('.tt-more');
    var checkClamp = function () {
      if (hookWrap.classList.contains('is-open')) return;
      more.hidden = !(hookText.scrollHeight > hookText.clientHeight + 2);
    };
    checkClamp();
    window.addEventListener('resize', checkClamp);
    more.addEventListener('click', function () {
      var open = hookWrap.classList.toggle('is-open');
      more.textContent = open ? T.less : T.more;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* forventet levering: afsendelse samme dag før cutoff på hverdage, ellers næste hverdag */
  var eta = root.querySelector('[data-eta]');
  if (eta) {
    var cutoff = parseInt(eta.dataset.cutoff, 10) || 14;
    var days = parseInt(eta.dataset.days, 10) || 1;
    var isWeekday = function (d) { return d.getDay() !== 0 && d.getDay() !== 6; };
    var ship = new Date();
    if (!(isWeekday(ship) && ship.getHours() < cutoff)) {
      do { ship.setDate(ship.getDate() + 1); } while (!isWeekday(ship));
    }
    var out = new Date(ship);
    var left = days;
    while (left > 0) {
      out.setDate(out.getDate() + 1);
      if (isWeekday(out)) left--;
    }
    eta.textContent = out.toLocaleDateString('da-DK', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  /* toast */
  var toast = document.getElementById('tt-toast');
  function showToast(title, text, cartTotal) {
    if (!toast) return;
    document.getElementById('tt-toast-title').textContent = title;
    document.getElementById('tt-toast-txt').textContent = text;
    var bar = document.getElementById('tt-ship-bar');
    var shipTxt = document.getElementById('tt-ship-txt');
    if (bar && shipTxt && threshold > 0 && typeof cartTotal === 'number') {
      var rest = threshold - cartTotal;
      shipTxt.textContent = rest > 0 ? T.missing.replace('[beløb]', fmt(rest)) : T.free;
      bar.style.width = Math.min(100, (cartTotal / threshold) * 100) + '%';
    }
    toast.classList.add('is-visible');
    clearTimeout(window.__ttToast);
    window.__ttToast = setTimeout(function () { toast.classList.remove('is-visible'); }, 4000);
  }

  function refreshCartBubble() {
    fetch(rootUrl + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !s['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () {});
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!state.available) return;
    atc.disabled = true;
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || T.error);
        var item = res.j;
        return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var vt = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
          showToast(T.added, item.quantity + ' × ' + item.product_title + vt + ' · ' + fmt(item.final_line_price), cart.total_price);
          refreshCartBubble();
          atc.classList.add('is-done');
          setTimeout(function () { atc.classList.remove('is-done'); }, 1600);
        });
      })
      .catch(function (err) {
        showToast(T.error, err.message);
      })
      .then(function () {
        atc.disabled = !state.available;
      });
  });

  /* sticky knap. Siden får luft forneden svarende til barens højde */
  var sticky = document.getElementById('tt-sticky');
  var anchor = document.getElementById('tt-atc-anchor');
  var stickyBtn = document.querySelector('[data-tt-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else atc.click();
    });
  }
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
    }).observe(anchor);
  }

  render();
})();